import { Type } from 'class-transformer';
import { JsonApiPayload } from 'services/interfaces/JsonApiPayload';
import { BrandingSettingsPayload } from './BrandingSettingsPayload';
import { ConnectionPayload } from './ConnectionPayload';
import { PolicySettingPayload } from './PolicyPayload';

export class ParkPayload extends JsonApiPayload {
  id: string;
  name: string;
  code: string;
  description: string;
  // pmsId: string;
  address: string;
  address2: string;
  address3: string;
  address4: string;
  city: string;
  state: string;
  postalCode: string;
  connectionId: string;
  country: string;
  email: string;
  emailDisplayName: string;
  phone: string;
  phone2: string;
  logoUrl: string;
  homepageUrl: string;
  lat: string;
  lng: string;
  nextBookingDate: string;
  timeZone: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;

  @Type(() => BrandingSettingsPayload)
  brandingSetting: BrandingSettingsPayload;

  @Type(() => ConnectionPayload)
  connection: ConnectionPayload;
  
  @Type(() => PolicySettingPayload)
  policySetting: PolicySettingPayload;

  static getSchema() {
    return super._getSchema(this, ['brandingSetting', 'connection', 'policySetting']);
  }
}
